var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("footer-navigation", {
        attrs: { "current-page": _vm.Resources.Layout.MarketingServicesLink },
      }),
      _vm._v(" "),
      _c("base-hero", {
        attrs: {
          title: `${_vm.platformName} Performance Team`,
          type: "marketing",
        },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "gfu-become-creator-hero__content _mb-6" },
                  [
                    _vm._v(
                      "\n                Boost your project’s reach with our expert team. "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                We'll manage your promotion across Facebook, Instagram, Messenger, Threads, Google,\n                and Reddit - from campaign preview to pledge manager.\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "base-link",
                  {
                    staticClass:
                      "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--wide _tac",
                    attrs: { url: _vm.contactUrl },
                  },
                  [_vm._v("\n                Complete the form\n            ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "gfu-layout-wrapper gfu-layout-wrapper--narrow _pb-6" },
        [
          _c("marketing-services-benefits", {
            attrs: {
              "marketing-services-benefits": _vm.marketingServicesBenefits,
            },
          }),
          _vm._v(" "),
          _c("h2", { staticClass: "gfu-hd gfu-hd--h1" }, [
            _vm._v("Marketing services"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "gfu-bt gfu-bt--b1 _mb-6" }, [
            _vm._v("Bring your project the attention it deserves."),
          ]),
          _vm._v(" "),
          _c("marketing-services-values", {
            attrs: { "marketing-services-values": _vm.marketingServicesValues },
          }),
          _vm._v(" "),
          _c("h2", { staticClass: "gfu-hd gfu-hd--h1 _my-6" }, [
            _vm._v("They trusted us"),
          ]),
          _vm._v(" "),
          _c("testimonials-slider", {
            attrs: {
              testimonials: _vm.testimonials,
              page: "MarketingServices",
            },
          }),
          _vm._v(" "),
          _c("h2", { staticClass: "gfu-hd gfu-hd--h1 _mb-6" }, [
            _vm._v("Reach out"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "gfu-box gfu-box--flat gfu-box--huge _my-6 gfu-bt gfu-bt--b1 _tac",
            },
            [
              _c("div", {
                staticClass: "_fa _tc--accent fa-4x _fa--envelope _mb-6",
              }),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "Contact us for a custom marketing plan for your project."
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "_mt-6" },
                [
                  _c(
                    "base-link",
                    {
                      staticClass:
                        "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--wide _tac",
                      attrs: { url: _vm.contactUrl },
                    },
                    [
                      _vm._v(
                        "\n                    Get personalized offer\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }